module.exports = import("https://esm.sh/@tiptap/extension-link@2.4.0");;